export default __webpack_public_path__ + "static/8-98d3f1118e006252d3cd309f1bb11fba.webp";